import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { faGasPump } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'cr-gauge',
    templateUrl: './gauge.component.html',
    styleUrls: ['./gauge.component.scss']
})
export class CRGaugeComponent implements OnInit {
    @ViewChild('range') rangeMeter : ElementRef;
    @Input() hideTitle : boolean = true;
    @Input() valor : number = 0 ;
    @Input() minValue : number = 0 ;
    @Input() maxValue : number = 100 ;
    @Input() unidad : string = "" ;
    @Output() ValueChange = new EventEmitter<any>();
    

    public icons = {
        gas : faGasPump
    }

    constructor() { }

    ngOnInit(): void {
    }
    rangeChange(e) {
        //this.valor = e; 
        this.ValueChange.emit(this.valor);
    }
    // dynamicStyles(): any {
    //     let r = (-90 + (( this.valor * 180) / this.maxValue ))
    //     return {'transform': 'rotate(' + r + 'deg)' };
    // }
}
